import {Flex} from 'src/design/atoms/Flex';
import React from 'react';
import type {FeatureFlagEnum} from 'src/api/ProactApiClient';
import {FeatureFlagGuard} from 'src/app/auth/FeatureFlagGuard';

export interface ContentWrapperProps {
  featureFlag?: FeatureFlagEnum;
  children?: React.ReactNode;
}

export const ContentWrapper: React.FC<ContentWrapperProps> = ({
  children,
  featureFlag,
}) => (
  <FeatureFlagGuard
    requiredFeatureFlag={featureFlag}
    showDisabledMessage={true}>
    <Flex direction="column" w="auto">
      {children}
    </Flex>
  </FeatureFlagGuard>
);
